module.exports = __webpack_public_path__ + "img/q20.d4581773.jpeg";